module.exports = __webpack_public_path__ + "static/img/framework.49e650a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/framework.jpg
// module id = mPf9
// module chunks = 1